import { Grid } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'
import MiniNotesLoading from './MiniNotesLoading'

type Props = {
  isSingleCardPage?: boolean
}

export default function MiniNotesCardSkeleton({ isSingleCardPage = true }: Props): JSX.Element {
  const [t] = useTranslation()

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton isSingleCardPage={isSingleCardPage} heading={t('tree-person.notes.header')}>
        <MiniNotesLoading />
      </SectionCardSkeleton>
    </Grid>
  )
}
